<template>
  <div>
    <el-table
        :data="responseDataPackages"
        border
        :max-height="$tableMaxHeight"
        :header-cell-style="headerCellStyle"
        v-loading="isLoading"
    >

      <el-table-column
          fixed="left"
          type="selection"
          align="center"
      />

      <el-table-column
          fixed="left"
          type="index"
          label="STT"
          align="center"
      />

      <el-table-column
          fixed="left"
          label="Tên Gói"
          width="250"
          align="left"
      >
        <template v-slot:default="scope">
          <span>{{ scope.row.namePackage }}</span>
        </template>
      </el-table-column>

      <el-table-column
          fixed="left"
          label="Mô tả"
          align="left"
      >
        <template v-slot:default="scope">
          <span>{{ scope.row.descriptionPackage }}</span>
        </template>
      </el-table-column>

      <el-table-column
          fixed="right"
          label="Tác vụ"
          width="215"
          align="center"
      >
        <template v-slot:default="scope">
          <div style="display: flex; justify-content: center">
            <el-button
                v-if="!scope.row.delActive"
                type="primary"
                size="mini"
                @click="confirmRestorePackages(scope.row, false)"
            >
              Khôi phục
            </el-button>

            <el-button
                size="mini"
                type="success"
                @click="handleUpdatePackage(scope.row)"
            >
              Sửa
            </el-button>
            <el-button
                v-if="scope.row.delActive"
                type="danger"
                size="mini"
                @click="confirmDeletePackages(scope.row, true)"
            >
              Xoá
            </el-button>
          </div>
        </template>
      </el-table-column>

      <template #empty>
        <div style="text-align: center; font-size: 16px; color: #43a0ff;">
          <i class="el-icon-warning"></i>
          <span> Không có dữ liệu! </span>
        </div>
      </template>
    </el-table>

    <!--  Chỉnh sửa gói  -->
    <DefaultLayoutDialog
        v-bind:title="`Chỉnh sửa gói - ${dataUpdatePackage.namePackage}`"
        width="30%"
        :isOpen="visibleDialog.updateForm"
        @update:isOpen="setUpdateForm"
    >
      <FormUpdateDialogPackage
          :data-update="this.dataUpdatePackage"
          @closeDialogUpdate="setUpdateForm"
      />
    </DefaultLayoutDialog>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {OperationPackage} from "@/services/PackageService";
import DefaultLayoutDialog from "@/components/FinanceVer2/managePackages/components/dialog/DefaultLayoutDialog.vue";
import FormUpdateDialogPackage
  from "@/components/FinanceVer2/managePackages/components/dialog/elements/FormUpdateDialogPackage.vue";

const props = {
  tab: ""
}

const headerCellStyle = () => {
  return {
    backgroundColor: "#78a5e7",
    color: "#fff",
  }
}

export default {
  components: {
    DefaultLayoutDialog,
    FormUpdateDialogPackage,
  },
  props: props,
  data() {
    return {
      visibleDialog: {
        updateForm: false,
      },
      dataUpdatePackage: {},
    }
  },
  computed: {
    ...mapState("packageStore", [
      "responseDataPackages",
      "isLoading",
    ]),
  },
  methods: {
    headerCellStyle,
    fetchDeletePackages(id, status) {
      OperationPackage.deletePackages(id, status)
          .then((res) => {
            this.$store.dispatch("packageStore/deletePackages", id);
            this.$message({
              type: 'success',
              message: res.data.message,
            });
          })
          .catch((err) => {
            console.log(err)
            this.$message({
              type: 'error',
              message: 'Lỗi!'
            });
          })
    },

    confirmDeletePackages(row, status) {
      this.$confirm(`Bạn có chắc muốn xoá gói "${row.namePackage}"`, 'Thông báo!', {
        confirmButtonText: 'Xác nhận',
        cancelButtonText: 'Huỷ bỏ',
      }).then(() => {
        this.fetchDeletePackages(row.id, status);
      })
    },

    confirmRestorePackages(row, status) {
      this.$confirm(`Bạn có chắc muốn khôi phục gói "${row.namePackage}"`, 'Thông báo!', {
        confirmButtonText: 'Xác nhận',
        cancelButtonText: 'Huỷ bỏ',
      }).then(() => {
        this.fetchDeletePackages(row.id, status);
      })
    },

    setUpdateForm(isOpen) {
      this.visibleDialog.updateForm = isOpen;
    },

    async handleUpdatePackage(row) {
      this.dataUpdatePackage = row;
      this.visibleDialog.updateForm = true;
    }
  }
}
</script>

<style lang="scss" scoped>

/deep/ .el-loading-spinner {
  transform: translateY(-50%);
}
</style>